import React, { useState, useEffect } from 'react';
import InputLabel from '../../../sharecomponents/InputLabel';
import CloseButton from '../../../sharecomponents/CloseButton';
import { activeDialog } from '../../../../utils/Common';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Post from '../../../../utils/Post copy';

const EditarTipoPerfil = (p) => {
    const close = p.close ?? (() => { });
    const [data, setdata] = useState({ ...(p.data ?? {}), passsword: "" });
    const [dialog, setdialog] = useState({ show: false });
    const [loader, setloader] = useState(false);
    const ldr = (<div className='w-100 h-100 top-left-front bg-white3 blur-s'><div className='loader-local' /></div>);
    useEffect(() => {

    }, []);

    const change = (e) => {
        setdata({ ...data, [e.target.name]: e.target.value });
    }

    const actualizar = async () => {
        if (data.nombre == "") {
            activeDialog(setdialog, "El nombre no puede estar vacio", "error", "Error");
            return;
        }
        let resp = await Post('secure/users/types/update', { id: data.id, nombre: data.nombre }, setloader);
        if (!resp.estatus) {
            activeDialog(setdialog, resp.msj, 'error', 'Error');
            return;
        }
        close(true);
    }

    return (
        <div className='w-100 h-100 blur-s bg-black4 p-2 contenedor round-s overflow' style={{ position: "fixed", top: 0, left: 0, zIndex: 10 }}>
            <CloseButton close={() => close(false)} floatElement={true} />
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='bw-500 shadow-multi round-s bg-white p-2'>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='w-100 text-center text-l text-bold'>Editar tipo de perfil de usuario</div>
                        <InputLabel label='Nombre' name='nombre' value={data.nombre} change={change} />
                        <div className='w-100 text-center'>
                            <button className='btn btn-warning round-xxl mt-3 mb-4 shadow bw-400 text-bold' onClick={actualizar}>Actualizar</button>
                        </div>
                    </div>
                </div>
            </div>
            <VainillaDialog data={dialog} />
            {loader && ldr}
        </div>
    )
}

export default EditarTipoPerfil;